import React from "react";
import { InvoiceTemplate } from "../../Templates/InvoiceTemplate";

export const Invoice = () => {
  return <InvoiceTemplate />;
};